import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import views from './views';
import transitions from './transitions';
import { setGformHoneypot, evalScripts } from './gravityforms';

export default class BarbaApp {
	constructor() {
		setGformHoneypot();

		this.scrollPos = [];

		if (history.scrollRestoration) {
			history.scrollRestoration = 'manual';
		}

		barba.hooks.before(({ current, next, trigger }) => {
			//
		});

		barba.hooks.beforeLeave(({ current, next, trigger }) => {
			//
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			const leaveEvent = new CustomEvent('leave', {
				bubbles: true,
				detail: {
					current,
					next,
					trigger,
				},
			});

			document.dispatchEvent(leaveEvent);
		});

		barba.hooks.afterLeave(({ current, next, trigger }) => {
			//
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			const blessEvent = new CustomEvent('bless', {
				bubbles: true,
				detail: {
					current,
					next,
					trigger,
				},
			});

			next.container.dispatchEvent(blessEvent);
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				this.scrollPos.push({
					x: barba.history.current.scroll.x,
					y: barba.history.current.scroll.y,
				});
			}
		});

		barba.hooks.afterEnter(({ current, next, trigger }) => {
			if (trigger !== 'back') {
				// TODO: scrollen naar eventuele hash?
				window.scrollTo(0, 0);
			} else {
				window.scrollTo(...Object.values(this.scrollPos.pop()));
			}
		});

		barba.hooks.after(({ current, next, trigger }) => {
			evalScripts(next);

			document.body.setAttribute('tabindex', '-1');
			document.body.focus({ preventScroll: true });
		});

		barba.use(barbaPrefetch, {
			limit: 5,
		});

		barba.init({
			debug: window.WPDATA.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				const url = new URL(href);

				if (!url) {
					return false;
				}

				// Prevent external links
				if (url.hostname !== window.location.hostname) {
					return true;
				}

				// Prevent if not a /-link
				if (!url.pathname.endsWith('/')) {
					return true;
				}

				return false;
			},
			views,
			transitions,
		});
	}
}
